import { GlobalOutlined } from '@ant-design/icons'
import { Button, Dropdown, type MenuProps } from 'antd'
import { useTranslation } from 'react-i18next'
import { SUPPORTED_LANGUAGES, changeLanguage, currentLanguage } from '@/app/i18n'

const LABELS: Record<string, string> = {
  uz: "O'zbekcha",
  fa: 'فارسی',
  ru: 'Русский',
  en: 'English',
}

/**
 * Til tanlash — tanlov HECH QAYERDA SAQLANMAYDI (`app/i18n/index.ts`
 * izohiga qarang: bu anonim, bir martalik sahifa, `localStorage` bu yerda
 * qo'shimcha iz bo'lardi). Ro'yxatda til O'Z NOMI bilan yoziladi
 * ("Русский", tarjima qilingan "Russian" emas) — noto'g'ri tilda ochilib
 * qolgan mehmon o'z tilini shundagina topa oladi.
 */
export function LanguageSwitcher() {
  const { t, i18n } = useTranslation()
  const active = currentLanguage()
  void i18n.resolvedLanguage // til o'zgarganda qayta chizilsin

  const items: MenuProps['items'] = SUPPORTED_LANGUAGES.map((lang) => ({
    key: lang,
    label: LABELS[lang] ?? lang,
  }))

  return (
    <Dropdown
      menu={{
        items,
        selectable: true,
        selectedKeys: [active],
        onClick: ({ key }) => {
          const next = SUPPORTED_LANGUAGES.find((l) => l === key)
          if (next) changeLanguage(next)
        },
      }}
      trigger={['click']}
    >
      <Button type="text" icon={<GlobalOutlined />} aria-label={t('language.label')}>
        {active.toUpperCase()}
      </Button>
    </Dropdown>
  )
}
